import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';

import {
  renderPhoneField,
  renderEmailField,
  phoneParser,
  phoneFormatter,
} from '../../../utils/redux-form-helper';
import ContactInformationMultiple from './ContactInformationMultiple';

import messages from './messages';

type Props = {
  intl: Object,
  required?: boolean,
  disabled?: boolean,
};

const ContactInformationSection = ({ intl, required, disabled }: Props) => {
  const { applicationAdditionalPhoneEmailAndTypes } = useFlags();

  if (applicationAdditionalPhoneEmailAndTypes) {
    return (
      <ContactInformationMultiple
        intl={intl}
        required={required}
        disabled={disabled}
      />
    );
  }

  // Legacy single field implementation
  return (
    <div className="form-content">
      <Typography variant="titleLarge">
        {intl.formatMessage(messages.title)}
      </Typography>
      <Row>
        <Col xs={12} md={6}>
          <Field
            name="phoneNumber"
            component={renderPhoneField}
            className="input-lg"
            label={intl.formatMessage(messages.phoneLabel)}
            placeholder={intl.formatMessage(messages.phonePlaceholder)}
            showLabel
            parse={phoneParser}
            format={phoneFormatter}
            classes={classNames({ required })}
          />
        </Col>
        <Col xs={12} md={6}>
          <Field
            name="emailAddress"
            component={renderEmailField}
            className="input-lg"
            label={intl.formatMessage(messages.emailLabel)}
            placeholder={intl.formatMessage(messages.emailPlaceholder)}
            showLabel
            classes={classNames({ required })}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ContactInformationSection;
